// extracted by mini-css-extract-plugin
module.exports = {"templateWrapper":"styles_templateWrapper__2rKip","mainWrapper":"styles_mainWrapper__1Qt1c","content":"styles_content__3MMXX"};